export default "__VITE_ASSET__05bbca87__"